export const headerMap = {
  'car-records': ['引擎號碼', '車種', 'SFX NO', '工位', 'arg', '日期'],
  'car-infos': ['引擎號碼', 'SFX NO', '車種', '船次', '狀態', '建立時間'],
  'pio-records': ['安裝日期',  'arg', '車型(QRCode)',  '引擎編號',  '車身號碼'],
  'employee-records': ['員工姓名',  '員工編號',  'arg', '車種', 'SFX NO',  '組裝數量'],
  'car-statistics': [],
  'total-output': ['車種', 'SFX NO', '船次', '總數量']
}

export const fieldOrderMap = {
  'car-records': ['engineNo', 'carModelCode', 'sfxNo', 'stationDescription', 'arg', 'time'],
  'car-infos': ['engineNo', 'sfxNo', 'carModelCode', 'shippingNo', 'carStatus', 'createdAt'],
  'pio-records': ['assemblyCompletedAt', 'arg', 'qrCode', 'engineNo', 'idotNo'],
  'employee-records': ['employeeName', 'employeeNo', 'arg', 'modelCode', 'sfxNo', 'recordCount'],
  'car-statistics': [],
  'total-output': ['carModelCode', 'sfxNo', 'shippingNo', 'recordCount']
}

export const headerArgMap: {[reportCategory: string]: { [category: string]: string[] }} = {
  'car-records': {
    'moving': ['進場狀態', '出場狀態'],
    'assembly': ['組裝狀態', '組裝時間'],
    'quality': ['品檢狀態', '品檢時間'],
    'repair': ['修復狀態', '修復時間']
  },
  'employee-records': {
    'moving': ['行為'],
    'assembly': ['組裝部位'],
    'quality': ['組裝部位'],
    'repair': ['組裝部位']
  }
}

export const fieldArgMap: {[reportCategory: string]: { [category: string]: string[] }} = {
  'car-records': {
    'moving': ['movingInStatus', 'movingOutStatus'],
    'assembly': ['assemblyStatus', 'assemblyTimeRange'],
    'quality': ['qualityStatus', 'qualityTimeRange'],
    'repair': ['repairStatus', 'repairTimeRange']
  },
  'employee-records': {
    'moving': ['action'],
    'assembly': ['carPartDescription'],
    'quality': ['carPartDescription'],
    'repair': ['carPartDescription']
  }
}

export const titleMap = {
  'car-records': '車輛紀錄',
  'car-infos': '車籍資料',
  'pio-records': '項目(PIO)紀錄',
  'employee-records': '員工紀錄',
  'car-statistics': '車輛整體統計',
  'total-output': '總產量'
}
